import { render, staticRenderFns } from "./acknowledgment.vue?vue&type=template&id=0889d97e&"
import script from "./acknowledgment.vue?vue&type=script&lang=js&"
export * from "./acknowledgment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports